const bikeCc = [
    { "id": "50", "label": "26 - 50 κ.εκ." },
    { "id": "75", "label": "51 - 75 κ.εκ." },
    { "id": "100", "label": "76 - 100 κ.εκ." },
    { "id": "125", "label": "101 - 125 κ.εκ." },
    { "id": "150", "label": "126 - 150 κ.εκ." },
    { "id": "175", "label": "151 - 175 κ.εκ." },
    { "id": "200", "label": "176 - 200 κ.εκ." },
    { "id": "225", "label": "201 - 225 κ.εκ." },
    { "id": "250", "label": "226 - 250 κ.εκ." },
    { "id": "275", "label": "251 - 275 κ.εκ." },
    { "id": "300", "label": "276 - 300 κ.εκ." },
    { "id": "325", "label": "301 - 325 κ.εκ." },
    { "id": "350", "label": "326 - 350 κ.εκ." },
    { "id": "375", "label": "351 - 375 κ.εκ." },
    { "id": "400", "label": "376 - 400 κ.εκ." },
    { "id": "425", "label": "401 - 425 κ.εκ." },
    { "id": "450", "label": "426 - 450 κ.εκ." },
    { "id": "475", "label": "451 - 475 κ.εκ." },
    { "id": "500", "label": "476 - 500 κ.εκ." },
    { "id": "525", "label": "501 - 525 κ.εκ." },
    { "id": "550", "label": "526 - 550 κ.εκ." },
    { "id": "575", "label": "551 - 575 κ.εκ." },
    { "id": "600", "label": "576 - 600 κ.εκ." },
    { "id": "625", "label": "601 - 625 κ.εκ." },
    { "id": "650", "label": "626 - 650 κ.εκ." },
    { "id": "675", "label": "651 - 675 κ.εκ." },
    { "id": "700", "label": "676 - 700 κ.εκ." },
    { "id": "725", "label": "701 - 725 κ.εκ." },
    { "id": "750", "label": "726 - 750 κ.εκ." },
    { "id": "775", "label": "751 - 775 κ.εκ." },
    { "id": "800", "label": "776 - 800 κ.εκ." },
    { "id": "825", "label": "801 - 825 κ.εκ." },
    { "id": "850", "label": "826 - 850 κ.εκ." },
    { "id": "875", "label": "851 - 875 κ.εκ." },
    { "id": "900", "label": "876 - 900 κ.εκ." },
    { "id": "925", "label": "901 - 925 κ.εκ." },
    { "id": "950", "label": "926 - 950 κ.εκ." },
    { "id": "975", "label": "951 - 975 κ.εκ." },
    { "id": "1000", "label": "976 - 1000 κ.εκ." },
    { "id": "1025", "label": "1001 - 1025 κ.εκ." },
    { "id": "1050", "label": "1026 - 1050 κ.εκ." },
    { "id": "1075", "label": "1051 - 1075 κ.εκ." },
    { "id": "1100", "label": "1076 - 1100 κ.εκ." },
    { "id": "1125", "label": "1101 - 1125 κ.εκ." },
    { "id": "1150", "label": "1126 - 1150 κ.εκ." },
    { "id": "1175", "label": "1151 - 1175 κ.εκ." },
    { "id": "1200", "label": "1176 - 1200 κ.εκ." },
    { "id": "1225", "label": "1201 - 1225 κ.εκ." },
    { "id": "1250", "label": "1226 - 1250 κ.εκ." },
    { "id": "1275", "label": "1251 - 1275 κ.εκ." },
    { "id": "1300", "label": "1276 - 1300 κ.εκ." },
    { "id": "1325", "label": "1301 - 1325 κ.εκ." },
    { "id": "1350", "label": "1326 - 1350 κ.εκ." },
    { "id": "1375", "label": "1351 - 1375 κ.εκ." },
    { "id": "1400", "label": "1376 - 1400 κ.εκ." },
    { "id": "1425", "label": "1401 - 1425 κ.εκ." },
    { "id": "1450", "label": "1426 - 1450 κ.εκ." },
    { "id": "1475", "label": "1451 - 1475 κ.εκ." },
    { "id": "1500", "label": "1476 - 1500 κ.εκ." },
    { "id": "1525", "label": "1501 - 1525 κ.εκ." },
    { "id": "1550", "label": "1526 - 1550 κ.εκ." },
    { "id": "1575", "label": "1551 - 1575 κ.εκ." },
    { "id": "1600", "label": "1576 - 1600 κ.εκ." },
    { "id": "1625", "label": "1601 - 1625 κ.εκ." },
    { "id": "1650", "label": "1626 - 1650 κ.εκ." },
    { "id": "1675", "label": "1651 - 1675 κ.εκ." },
    { "id": "1700", "label": "1676 - 1700 κ.εκ." },
    { "id": "1725", "label": "1701 - 1725 κ.εκ." },
    { "id": "1750", "label": "1726 - 1750 κ.εκ." },
    { "id": "1775", "label": "1751 - 1775 κ.εκ." },
    { "id": "1800", "label": "1776 - 1800 κ.εκ." },
    { "id": "1825", "label": "1801 - 1825 κ.εκ." },
    { "id": "1850", "label": "1826 - 1850 κ.εκ." },
    { "id": "1875", "label": "1851 - 1875 κ.εκ." },
    { "id": "1900", "label": "1876 - 1900 κ.εκ." },
    { "id": "1925", "label": "1901 - 1925 κ.εκ." },
    { "id": "1950", "label": "1926 - 1950 κ.εκ." },
    { "id": "1975", "label": "1951 - 1975 κ.εκ." },
    { "id": "2000", "label": "1976 - 2000 κ.εκ." },
    { "id": "9999", "label": ">2000 κ.εκ." }
]

export default bikeCc;